/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



// refreshes mini cart:
// function refreshCart(){
//   document.dispatchEvent(new CustomEvent('theme:loading:end'));
// }
// opens cart drawer
function openCartDrawer(){
  document.dispatchEvent(new CustomEvent('theme:loading:end'));
  document.dispatchEvent(
    new CustomEvent('product:added', {
        bubbles: true,
        detail: {
            quantity: 1,
            // variant: 1
        }
    })
  )
}

document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
  bubbles: true
}));


// redirect afterlife member coming from email if the early access has ended
// e.g.: https://www.zerofoxtrot.com/?afterlifeMember=true&redirectURL=https://www.zerofoxtrot.com/collections/tanks&cutoffTime=11111112341
// cutoff time is a unix timestamp: http://www.unixtimestampconverter.com/
var urlParams = new URLSearchParams(window.location.search);
if (urlParams.get("afterlifeMember") && urlParams.get("cutoffTime") && urlParams.get("redirectURL") && zf_api.customer.isActiveAfterlife) {
  let now = new Date() / 1000 | 0;
  if (now > urlParams.get("cutoffTime")) {
    window.location.replace(urlParams.get("redirectURL"));
  }
}

// change the name of a collection with the query parameter collection_name
// e.g.: ?collection_name=New Jackets
if (urlParams.get("collection_name") != null && zf_api.pageType == "collection") {
  document.querySelector("h1.SectionHeader__Heading").innerText = urlParams.get("collection_name");
}


// Check if 'popUpCart' parameter is present and set to 'true'
if (urlParams.get("popUpCart") === "true") {
  document.body.classList.add("popUpCart");
}


/**
 * ----------------------------------------------------------------------------
 * Product Pages
 * ----------------------------------------------------------------------------
 */
(function () {
  let productMeta = document.querySelector(".ProductMeta.Custom");
  let productMetaMobile = document.querySelector(".productMetaMobile");
  let productMetaTabletUp = document.querySelector(".productMetaTabletUp");
  if (productMeta !== null && productMetaMobile !== null) {
    window.matchMedia("(max-width: 641px)").addEventListener("change", function (e) {
      if (e.matches) {
        productMetaMobile.appendChild(productMeta);
      } else {
        productMetaTabletUp.appendChild(productMeta);
      }
    });

    if (window.matchMedia('(max-width: 641px)').matches) {
      productMetaMobile.appendChild(productMeta);
    } else {
      productMetaTabletUp.appendChild(productMeta);
    }

    let madeInUSA = document.querySelector(".madeInUSA");
    let productSlideshow = document.querySelector(".Product__Slideshow .flickity-viewport");

    if (typeof (madeInUSA) != 'undefined' && madeInUSA != null) {
      productSlideshow.append(madeInUSA);
    }

    let printedInUSA = document.querySelector(".printedInUSA");


    if (typeof (printedInUSA) != 'undefined' && printedInUSA != null) {
      productSlideshow.append(printedInUSA);
    }

    let qualifiesForFreeShipping = document.querySelector(".qualifiesForFreeShipping");
    if (qualifiesForFreeShipping != null && window.zf_api.product.qualifiesForFreeShipping == true && window.zf_api.customer.isActiveAfterlife == false) {
      qualifiesForFreeShipping.style.display = "block"
    }
  }

})();

let widgetHeader = document.querySelector(".okeReviews-reviewsWidget-header");
let reviewsAggregate = document.querySelector(".okeReviews-reviewsAggregate");
if (widgetHeader !== null && reviewsAggregate !== null) {
  reviewsAggregate.parentNode.insertBefore(widgetHeader, reviewsAggregate.nextSibling);
}

/**
 * ----------------------------------------------------------------------------
 * Coming Soon Product Page
 * ----------------------------------------------------------------------------
 */

try {
  if (document.body.classList.contains('template-product')) {
    var buttonText = document.querySelector('.ProductForm__AddToCart.Button.Button--full.Button--secondary').innerText;
    if (buttonText == 'COMING SOON') {
      document.addEventListener('variant:changed', function (event) {
        document.querySelector('.ProductForm__AddToCart.Button.Button--full.Button--secondary').innerText = buttonText;
      });
    };
  }
} catch (e) { }

/**
 * ----------------------------------------------------------------------------
 * Login
 * ----------------------------------------------------------------------------
 */

// add redirect parameter to login link on protected afterlife pages
let customer_login_link = document.querySelector("#customer_login_link");
if (typeof (customer_login_link) != 'undefined' && customer_login_link !== null) {
  customer_login_link.href = customer_login_link.href + "?return_url=" + window.location.pathname;
}


/**
 * ----------------------------------------------------------------------------
 * Collection Page
 * ----------------------------------------------------------------------------
 */

let sizeFilter = document.querySelector('input[name="filter.v.option.size"]');
if (zf_api.pageType == "collection" && sizeFilter !== null) {
  reorderSidebarFilter();
  document.addEventListener('theme:loading:end', function () {
    reorderSidebarFilter();
  });
}
// reorders size list for the collection filter
function reorderSidebarFilter() {
  let filters = document.querySelectorAll(".CollectionFilters");
  for (i = 0; i < filters.length; i++) {
    if (filters[i].classList.contains("Drawer")) {
      var lg = filters[i].querySelector("input#drawer-filter-v-option-sizelg").closest(".Linklist__Item");
      var xl = filters[i].querySelector("input#drawer-filter-v-option-sizexl").closest(".Linklist__Item");
    } else {
      var lg = filters[i].querySelector("input#sidebar-filter-v-option-sizelg").closest(".Linklist__Item");
      var xl = filters[i].querySelector("input#sidebar-filter-v-option-sizexl").closest(".Linklist__Item");
    }
    lg.parentNode.insertBefore(xl, lg.nextSibling);
  }
}

/**
 * ----------------------------------------------------------------------------
 * Navigation
 * ----------------------------------------------------------------------------
 */

// makes accessories megamenu more narrow
(function () {
  let topNav = document.querySelectorAll(".Header__MainNav .HorizontalList .Header__LinkSpacer");
  for (let i = 0; i < topNav.length; i++) {
    if (topNav[i].innerText.toUpperCase() == "ACCESSORIES") {
      topNav[i].parentNode.parentElement.querySelector(".MegaMenu__Inner").style.maxWidth = "1000px"
    }
  }
})();

/**
 * ----------------------------------------------------------------------------
 * Footer Navigation
 * ----------------------------------------------------------------------------
 */

if (window.matchMedia('(max-width: 641px)').matches) {
  createToggleFooterNav();
}

window.matchMedia("(max-width: 641px)").addEventListener("change", function (e) {
  if (e.matches) {
    createToggleFooterNav();
  }
});



// creates toggle nav links in footer for mobile
function createToggleFooterNav() {
  let links = document.querySelectorAll(".Footer__Block--links");
  for (var i = 0; i < links.length; i++) {
    links[i].querySelector(".Footer__Title").innerHTML += `<span class="PlusIcon"></span>`;
    links[i].addEventListener("click", function (e) {
      let active = this.parentNode.querySelector(".active");
      this.classList.toggle("active");
      if (active !== null) {
        active.classList.remove("active");
      }
    }, false);
  }
}


/**
 * ----------------------------------------------------------------------------
 * Add Accessibility link
 * ----------------------------------------------------------------------------
 */

let linkList = document.querySelectorAll(".Linklist > .Linklist__Item > a");
for (let i = 0; i < linkList.length; i++) {
  let item = linkList[i];
  if (item.hash === "#enableAccessibility") {
    item.innerHTML = `<div data-acsb="trigger" aria-label="Open accessibility interface" class="AccessibilityIcon AccessibilityIcon--large" style="cursor: pointer;">
     <span alt="Accessibility Icon" role="button" title="Open Accessibility Interface" class="Icon-Wrapper--clickable">
     Enable Accessibility
         <svg class="Icon" version="1.1" fill="#fff" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" role="none" width="14px" height="16px" viewBox="0 0 626.271 799.198" enable-background="new 0 0 626.271 799.198" xml:space="preserve">
             <path d="M238.227,177.349c6.384,40.433,12.772,80.866,19.157,121.293c42.576,0,85.144,0,127.726,0	c25.701,0,40.646,65.978,10.521,72.235c-22.436,1.423-98.633,0.463-124.631,0.463c0.989,5.415,1.988,10.833,2.987,16.248	c51.665,0,103.321,0,154.986,0c9.195,0,17.061,5.711,20.229,13.781c32.791,68.137,65.588,136.269,98.38,204.41	c9.79-6.214,19.59-12.422,29.375-18.631c28.922-17.401,71.553,37.836,35.501,61.738c-25.555,19.011-78.58,64.696-104.11,41.32	c-38.654-75.534-75.422-148.847-112.331-223.83c-56.836,0-113.682,0-170.518,0c-9.4,0-17.865-6.876-20.887-15.233	c-14.215-94.856-28.64-186.408-43.063-280.587c-25.638-19.8-40.628-46.383-40.628-79.243c0-115.553,168.982-120.889,176.964-8.084	C300.745,123.681,281.12,167.296,238.227,177.349L238.227,177.349z M157.479,407.567l-12.29-82.02	c-342.506,240.784-15.94,655.734,328.51,385.439l-35.891-70.969C209.153,865.533-63.32,593.713,157.479,407.567z"></path>
         </svg>     
     </span>
     <span class="accessText">Accessibility Interface</span>
 </div>`;
  }
}

/**
* ----------------------------------------------------------------------------
* Tracktor Shipping App
* ----------------------------------------------------------------------------
*/

(function () {
  var tracktorPage = document.getElementById("tracktor");
  if (typeof (tracktorPage) != 'undefined' && tracktorPage != null) {
    elementReady("#tracktorOrderStatus > h1 > span").then(function (element) {
      var newText = "Package 1 of 2 (Scroll for Package 2)";
      if (element.innerText.indexOf("1 of 2") !== -1) {
        element.innerText = newText;
      } else if (element.innerText.indexOf("2 of 2") !== -1) {
        setTimeout(function () {
          document.querySelector("#tracktorOrderStatus > h1 > span").innerText = newText;
        }, 500);
      }
    });
    elementReady(".tracktorFulfillmentCol1").then(function (element) {
      var shippingDetails = element.querySelector("p");
      if (typeof (shippingDetails) != 'undefined' && shippingDetails != null) {
        if (shippingDetails.innerText == "Waiting for carrier to update tracking information, please try again later.") {
          shippingDetails.innerText = "Your order is being processed.";
        }
      }
    });
  }
})();


/**
* ----------------------------------------------------------------------------
* Announcement Bar
* ----------------------------------------------------------------------------
*/


if (zf_api.customer.isActiveAfterlife){
  const announcement = document.querySelector("#shopify-section-announcement");
  announcement.innerHTML = "";
}

async function fetchCartJSON() {
  const response = await fetch('/cart.js');
  const cart = await response.json();
  return cart;
}

function updateAnnouncementBar() {
  fetchCartJSON().then(cart => {
    let cartDot = document.querySelector(".Header__CartDot.is-visible");
    if (cartDot && cart.item_count > 0){
      cartDot.innerText = cart.item_count;
    }
    let announcementBarDefaultHTML = document.querySelector(".AnnouncementBar ul li:nth-of-type(1) p.AnnouncementBar__Content").innerHTML;
    let freeShippingThresholdCents = zf_api.freeShippingThreshold * 75.0,
    subTotalPrice = cart.items_subtotal_price,
    thresholdRemaining = ((freeShippingThresholdCents - subTotalPrice) / 100).toLocaleString("en-US", {style:"currency", currency:"USD"}),
    announcementBar = document.querySelector(".AnnouncementBar ul li:nth-of-type(1) p.AnnouncementBar__Content");
    if (announcementBar) {
      if (subTotalPrice == 0) {
        // announcementBar.innerHTML = `Free USPS Shipping over ${zf_api.freeShippingThreshold.toLocaleString("en-US", {style:"currency", currency:"USD", maximumFractionDigits:0})}`;
        announcementBar.innerHTML = announcementBarDefaultHTML;
      } else if (freeShippingThresholdCents >= subTotalPrice) {
        announcementBar.innerHTML = `You're <strong>${thresholdRemaining}</strong> away from free US shipping!`;
      } else {
        announcementBar.innerHTML = `<strong>Congrats! Free US Shipping Unlocked</strong>`;
      }
    }
  });
}
updateAnnouncementBar();
document.addEventListener('theme:loading:end', function () {
  updateAnnouncementBar();
});



/**
 * ----------------------------------------------------------------------------
 * Patch from Maestroo for iOS 15. Delete when theme upgraded
 * ----------------------------------------------------------------------------
 */


(function () {
  if (window.Flickity) {
    let originalResizeMethod = window.Flickity.prototype.resize,
      lastWidth = window.innerWidth;

    window.Flickity.prototype.resize = function () {
      if (window.innerWidth === lastWidth && this.maxCellHeight > 0) {
        return;
      }

      lastWidth = window.innerWidth;
      originalResizeMethod.apply(this, arguments); // Call original method
    }
  }
})();

(function () {
  window.PhotoSwipe = new Proxy(window.PhotoSwipe, {
    construct(target, args) {
      let instance = new target(...args);

      let originalUpdateSize = instance.updateSize,
        lastWidth = null;

      instance.updateSize = function () {
        if (lastWidth === null || lastWidth !== window.innerWidth) {
          originalUpdateSize(this, arguments);
        }

        lastWidth = window.innerWidth;
      }

      return instance;
    }
  });
})();

const zfCart = (function () {
  function fetchCartData() {
    return fetch(`${window.routes.cartUrl}.js`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    })
      .then(response => {
        if (response.ok) {
          return response.json();
        } else {
          throw new Error('Network response was not ok');
        }
      })
      .catch(error => {
        console.error('Error fetching cart contents:', error);
        throw error;
      });
  }

  function getCart() {
    return fetchCartData(); // Return the promise
  }

  return {
    getCart,
  };
})();

if (typeof window.Shopify !== 'undefined') {
  window.Shopify.getCart = zfCart.getCart;
}

// Call the getCart function and assign the returned promise to a variable
// let cartPromise = zfCart.getCart();

// You can access the object properties using the then method of the returned promise
// cartPromise.then(cartContents => {
//   console.log(cartContents);
// }).catch(() => {});
